import { useAthleteContext } from '../context/AthleteContext';
import { readGarminReturnAthlete, clearGarminReturnAthlete } from '../utils/garminRedirect';
import { hasPendingRegistrationConnections } from '../utils/pendingRegistrationConnections';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { NmButton } from '../components/NmButton';

/**
 * OAuth return landing — API redirects here after Garmin connect (client=pwa).
 * Successful same-page OAuth returns to connections (or unfinished onboarding).
 */
export function GarminCallbackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isCoach, athletes, selectAthlete } = useAthleteContext();
  const [returnAthleteId] = useState(readGarminReturnAthlete);
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success') === '1';
  const error = searchParams.get('error') ?? '';
  const returnPath = hasPendingRegistrationConnections() ? '/register' : '/settings/connections';
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (isCoach && returnAthleteId != null && athletes.some(athlete => athlete.id === returnAthleteId)) {
      selectAthlete(returnAthleteId);
    }
    if (success) {
      clearGarminReturnAthlete();
      navigate(returnPath, { replace: true });
      return;
    }
    setDone(true);
  }, [success, error, navigate, returnPath, isCoach, athletes, selectAthlete, returnAthleteId]);

  if (!done) {
    return (
      <div className="flex-center" style={{ minHeight: '100dvh', background: 'var(--surface-0)' }}>
        <p style={{ color: 'var(--fg-3)' }}>{t('athleteSettings.garminConnecting')}</p>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: 'var(--surface-0)',
      }}
    >
      <div style={{ maxWidth: 400, textAlign: 'center' }}>
        <h1 style={{ fontSize: 20, marginBottom: 12 }}>
          {success ? t('athleteSettings.garminConnected') : t('athleteSettings.error.garminFailed')}
        </h1>
        {!success && error && (
          <p style={{ color: 'var(--fg-3)', marginBottom: 16, fontSize: 14 }}>{error}</p>
        )}
        <NmButton variant="primary" onClick={() => {
          clearGarminReturnAthlete();
          navigate(returnPath, { replace: true });
        }}>
          {t('common.back')}
        </NmButton>
      </div>
    </div>
  );
}
